import { styled } from '@mui/material';

import { Typography, Tooltip } from '@app-velocity/ui';

import { useI18n } from '@app-velocity/i18n';
import { PrivacyIcon } from '@app-velocity/icons';

const Header = styled('div')(({ theme }) => ({
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'space-between',
  padding: theme.spacing(2),
}));

const FlowsText = styled(Typography)({
  fontSize: 13,
  fontWeight: 500,
  color: 'var(--text-text-tertiary-color)',
});

const SecurityText = styled(Typography)({
  fontSize: 13,
  fontWeight: 500,
  color: 'var(--success-success-icon-primary-color)',
});

const SecurityInfo = styled('div')(({ theme }) => ({
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'space-between',
  gap: theme.spacing(1),
}));

export const ListHeader = () => {
  const { t } = useI18n();

  return (
    <Header>
      <FlowsText>{t('prototypes:flows_on_this_page')}</FlowsText>

      <Tooltip
        title={t('prototypes:safety_tip_description')}
        sx={{ margin: 8, padding: 8 }}
      >
        <SecurityInfo>
          <SecurityText>{t('prototypes:safety_tip')}</SecurityText>
          <PrivacyIcon />
        </SecurityInfo>
      </Tooltip>
    </Header>
  );
};
